import React, { useState, useEffect } from "react";
import logo from "./img/logo_mynextID.svg";
import "./App.css";
import config from "./config";
import { TextField, Button } from "@mui/material";
import QrCodeScanner from "./components/qrCodeScanner";
import { start } from "repl";

function App() {
  const [status, setStatus] = useState("");
  const [inputValue, setInputValue] = useState("");

  function onInputChange(e: React.ChangeEvent<HTMLInputElement>) {
    setInputValue(e.target.value);
  }

  useEffect(() => {
    if (inputValue !== "") {
      startTest();
      
    }
  }, [inputValue]);

  function startTest() {
    if (inputValue === "") {
      setStatus("Please enter URL");
      return;
    }
    setStatus("Test started...");
    fetch(config.app_url + "?request_url=" + encodeURIComponent(inputValue))
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          setStatus("Error: " + data.error);
          return;
        }
        setStatus("Test finished successfully! Result: " + data.redirect_uri);
      });
  }

  function onQrScan(result: string) {
    console.log("QR code scanned: " + result);
    setInputValue(result);
  }

  return (
    <div className="App">
      <header className="App-header">
        <div className="container">
          <img
            src={logo}
            alt=""
            className="logo"
            onClick={() => {
              window.open("https://mynext.id/", "_blank");
            }}
          />

          <h2 className="title">MyNextID mDL App</h2>

          <p style={{ margin: "40px 0 10px" }}>Start test by scanning QR code:</p>

          <QrCodeScanner
            qrBorderSize="100px"
            onScanResult={onQrScan}
            elementsWhenOffline={
              <div>
                <p style={{ margin: "20px 0" }}>
                  or paste the URL with mdoc schema in the
                  input field below and click on the button.
                </p>

                <TextField
                  sx={{ width: "100%" }}
                  id="outlined-basic"
                  label="URL with mdoc schema"
                  variant="outlined"
                  onChange={onInputChange}
                />
                
                <button className="btn btn-primary m-show" style={{margin: "20px 0"}} onClick={startTest}>
                  Start app test with URL
                </button>

                <p style={{ overflowWrap: "anywhere", margin: "20px 0" }}>
                  <b>Status:</b> <br />
                  {status}
                </p>
              </div>
            }
          />
        </div>
      </header>
    </div>
  );
}

export default App;
